<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar title="待充值订单">
      </black-bar>
    </div>
    <!-- <div>{{content}}</div> -->
    <div class="cardInfo">
      <div class="li">
        <span class="key">卡号：</span>
        <span class="val">{{cardInfo.printNo}}</span>
      </div>
      <div class="li">
        <span class="key">余额：</span>
        <span class="val">{{cardInfo.balance/100}}元</span>
      </div>
    </div>
    <div v-if="list.length>0">
      <ul class="order-list"
          v-for="(item,index) in list"
          :key="index">
        <div class="li-title">
          <!-- <img src="../assets/img/icon_dd.png" alt=""> -->
          <div class="key">订单号：</div>
          <div class="val">{{item.orderno}}</div>
          <button class="refundbtn" @click="refundbtnClicked(item.orderno)">退款</button>
        </div>
        <li>
          <div class="key">充值金额</div>
          <div class="val">{{item.txnamt/100}}元</div>
        </li>
        <li>
          <div class="key">充值方式</div>
          <div class="val">{{item.paytype}}</div>
        </li>
        <li>
          <div class="key">充值状态</div>
          <div class="val val-stste">{{item.payst}}</div>
        </li>
        <li>
          <div class="key">充值时间</div>
          <div class="val">{{item.txndate}} {{item.txntime}}</div>
        </li>
      </ul>
      <div class="tips">
        说明：
        <br>
        进入充值页面并点击“确认”，继续未完成订单的充值操作。
      </div>
    </div>
    <div v-else>
      <img class="empty" src="../assets/img/img_empty.png" alt="">
    </div>
    <alert-card :isShow="isShowAlert"
               title='退款提示'
               content="请确认是否进行退款？"
               :confirmHandle="alertConfirm"
               :cancelHandle="alertCancel"
               @isShow='isShow'>
    </alert-card>
  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
import alertCard from '@/components/alertCard'
export default {
  name: 'payWaitList',
  data () {
    return {
      loading: true,
      cardInfo: {},
      isShowAlert: false,  //弹窗
      refundOrderNo: '',
      list: [],
      content:{}
    }
  },
  components: {
    blackBar,
    alertCard
  },
  created () {


  },
  mounted () {
    const that = this;
    // window.android.getRefundList(true)
    window.refundList = that.refundList;
    window.refundResult = that.refundResult
  },
  created () {

    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    refundList (val) {
      // this.content = val
      // this.textList = val.data.recordBean.transactionRecord;
      if (val.code == '0000') {
        this.cardInfo = val.data
        this.list = val.data.refundList;
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: val.message
        })
      }
    },
    refundResult(res) {
      if (res.code == '0000') {
        if(res.data.refundResult) {//退款成功
          this.goRouter('refundSuccess')
        }else {
          this.goRouter('refundFail')
        }
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: res.message
        })
      }
      
    },
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    },
    refundbtnClicked(orderNo) {//退款
      console.log(orderNo)
      this.isShowAlert = true
      this.refundOrderNo = orderNo
    },
    isShow() {
      this.isShowAlert = false
      console.log('isShow=',this.isShowAlert)
    },
    alertConfirm() {
      this.isShowAlert = false
      if (this.refundOrderNo != '') {
        window.android.clickPayBack(true, this.refundOrderNo)
      }
    },
    alertCancel() {
      this.isShowAlert = false
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
  background-color: #f5f5f5;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.cardInfo {
  width: calc(92% - 64px);
  margin-left: 4%;
  margin-top: 16px;
  height: 96px;
  padding: 32px;
  background: #4a8ef7;
  border-radius: 16px 16px 16px 16px;
  .li {
    display: flex;
    height: 40px;
    line-height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 16px;
    .key {
      width: 100px;
      text-align: left;
    }
    .val {
      width: calc(100% - 100px);
      text-align: right;
    }
  }
}
.order-list {
  width: 92%;
  margin: 16px 4%;
  padding-bottom: 32px;
  // padding: 24px 32px;
  // height: 298px;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  .li-title {
    display: flex;
    height: 96px;
    margin-left: 32px;
    margin-right: 32px;
    margin-bottom: 8px;
    line-height: 96px;
    border-bottom: 1px dashed #dcdcdc;
    font-size: 28px;
    font-weight: 500;
    .key {
        width: 120px;
        // height: 40px;
        line-height: 88px;
        margin-top: 8px;
        text-align: left;
        color: #333;
      }
      .val {
        width: calc(100% - 220px);
        line-height: 88px;
        margin-top: 8px;
        text-align: left;
        color: #333;
      }
      .refundbtn {
        width: 120px;
        margin-top: 24px;
        height: 56px;
        border: 1px solid #4A8EF7;
        border-radius: 28px;
        background-color: #fff;
        color: #4A8EF7;
        font-size: 28px;
      }
  }
  li {
    display: flex;
    height: 40px;
    font-size: 28px;
    margin: 16px 32px 0 32px;
    .key {
      width: 130px;
      line-height: 40px;
      // margin-left: 32px;
      text-align: left;
      color: #999999;
    }
    .val {
      width: calc(100% - 130px);
      line-height: 40px;
      text-align: right;
      color: #333333;
    }
    .val-stste {
      color: #F28D37;
    }
  }
}
.tips {
  width: calc(92% - 64px);
  margin-left: 4%;
  margin-top: 16px;
  color: #999999;
  font-size: 24px;
  text-align: left;
}
.empty {
  width: 55%;
  margin-top: 132px;
}
</style>
